import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { safeLocalStorage as localStorage, safeSessionStorage as sessionStorage } from "@/lib/safeStorage";
import { Loader2 } from "lucide-react";

export default function GoogleCallback() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current || user === null) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    let context;
    try { context = JSON.parse(sessionStorage.getItem("google_oauth_context") || "null"); } catch {}
    sessionStorage.removeItem("google_oauth_context");
    const returnPath = context?.mode === "link" || user ? "/app/sicurezza" : "/";
    if (!code || !state || state !== context?.state || !context?.verifier) {
      sessionStorage.setItem("rv_logged_out", "1");
      navigate(returnPath, { replace: true, state: { googleError: params.get("error") ? "Operazione Google annullata." : "Richiesta Google non valida o scaduta. Riprova." } });
      return;
    }
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUri = window.location.origin + "/auth/google";
    api
      .post("/auth/google/callback", { code, redirect_uri: redirectUri, state, code_verifier: context.verifier })
      .then(({ data }) => {
        if (context.mode === "link") {
          toast.success("Google collegato al tuo account. Potrai usarlo per i prossimi accessi.");
          navigate("/app/sicurezza", { replace: true });
          return;
        }
        if (data && data.twofa_required) {
          sessionStorage.setItem("markoo_2fa", JSON.stringify(data));
          navigate("/", { replace: true });
          return;
        }
        if (data && data.access_token) localStorage.setItem("rv_token", data.access_token);
        sessionStorage.removeItem("rv_logged_out");
        setUser(data);
        navigate("/app/dashboard", { replace: true });
      })
      .catch((error) => { sessionStorage.setItem("rv_logged_out", "1"); navigate(returnPath, { replace: true, state: { googleError: formatApiErrorDetail(error.response?.data?.detail) || "Operazione Google non riuscita. Riprova o accedi con email e password." } }); });
  }, [navigate, setUser, user]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-muted-foreground" data-testid="google-callback-loading">
      <Loader2 className="w-7 h-7 animate-spin text-primary" />
      <p className="text-sm" data-testid="google-callback-status">Verifica Google in corso…</p>
    </div>
  );
}
